<ui-mobile-navigation
  (categoryChanged)="onCategoryChange($event)"
  [currentCategoryId]="currentCategoryId()"
  view="main">
</ui-mobile-navigation>
